import { render, staticRenderFns } from "./AllBackupServers.vue?vue&type=template&id=6576b98c&"
import script from "./AllBackupServers.vue?vue&type=script&lang=ts&"
export * from "./AllBackupServers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports